export const PUBSUB_TOPICS = {
  PEER_DISCOVERY: '/p2p/peer-discovery/1.0.0',
  MESH_HEARTBEAT: '/p2p/mesh-heartbeat/1.0.0',
  ORG_GLOBAL: '/p2p/org-global/1.0.0',
  SIX: (sixId: string) => `/p2p/six/${sixId}/1.0.0`,
  USER: (userId: string) => `/p2p/user/${userId}/1.0.0`,
};

export const MESH_HEARTBEAT_TOPIC = PUBSUB_TOPICS.MESH_HEARTBEAT;
export const ORG_GLOBAL_TOPIC = PUBSUB_TOPICS.ORG_GLOBAL;
export const SIX_TOPIC = (sixId: string) => PUBSUB_TOPICS.SIX(sixId);
export const USER_TOPIC = (userId: string) => PUBSUB_TOPICS.USER(userId);
